require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-relazioni-e-conferenze-ilaria-giannetti-the-n-2-chiasso-san-gottardo-motorway-the-design-and-construction-of-143-km-of-concrete-zurigo-26-gennaio-2019.json") })
        }
      }, "path---en-relazioni-e-conferenze-ilaria-giannetti-the-n-2-chiasso-san-gottardo-motorway-the-design-and-construction-of-143-km-of-concrete-zurigo-26-gennaio-2019");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-relazioni-e-conferenze-ilaria-giannetti-the-n-2-chiasso-san-gottardo-motorway-the-design-and-construction-of-143-km-of-concrete-zurigo-26-gennaio-2019!./.cache/json/en-relazioni-e-conferenze-ilaria-giannetti-the-n-2-chiasso-san-gottardo-motorway-the-design-and-construction-of-143-km-of-concrete-zurigo-26-gennaio-2019.json
// module id = 612
// module chunks = 231608221292675